import React from 'react'

import { Form, Col, AsyncSelect } from '_zari/core'

import { ClearInputGroup } from 'sharedComponents/utils'

import * as ProductosService from 'services/producto.service'

const ProductoPromocionFormGroup = ({ fIsSubmitting, iError, values, setValues }) => {
  const onChange = pickedProducto => {
    values._idProductoPromocion = pickedProducto._idProducto
    values._idProductoPresentacionPromocion = pickedProducto.value
    values.nombreProductoPromocion = pickedProducto.label
    values.unidadMedidaPromocion = pickedProducto.unidadMedida

    setValues(values)
  }

  const clickClear = () => {
    values._idProductoPromocion = ''
    values._idProductoPresentacionPromocion = ''
    values.nombreProductoPromocion = ''
    values.unidadMedidaPromocion = ''

    setValues(values)
  }

  const loadOptions = (inputValue, resolve) => {
    ProductosService.obtenerAsPromocionesSelect2({
      busqueda: inputValue
    }).then(({ data }) => resolve(data))
  }

  return (
    <Form.Group>
      <Form.Label text='PROD PROMOCION' htmlFor='input-productoPromocion' md={4} alignRightAt='md' />
      <Col md={8}>
        {values._idProductoPresentacionPromocion ? (
          <ClearInputGroup
            id='input-productoPromocion'
            iValue={values.nombreProductoPromocion}
            clickClear={clickClear}
          />
        ) : (
          <AsyncSelect
            selectId='select2-productoPromocion'
            disabled={fIsSubmitting}
            loadOptions={loadOptions}
            onChange={onChange}
          />
        )}
        {iError && <Form.Feedback type='invalid'>{iError}</Form.Feedback>}
      </Col>
    </Form.Group>
  )
}

export default React.memo(ProductoPromocionFormGroup)
